const BASE_PATH = `/images/gut-assessment`;

const gutAssessmentImages = {
  // Landing page
  background: `${BASE_PATH}/landing/background.svg`,
  landing: `${BASE_PATH}/landing/landing.svg`,
  leftArrow: `${BASE_PATH}/landing/left-arrow.svg`,
  checkboxUnchecked: `${BASE_PATH}/landing/checkbox-uncheck.svg`,
  checkboxChecked: `${BASE_PATH}/landing/checkbox-checked.svg`,

  // Question page
  questionBackground: `${BASE_PATH}/question/background.svg`,
  questionHeader: `${BASE_PATH}/question/header.svg`,
  questionArrowBack: `${BASE_PATH}/question/arrow-back.svg`,
  questionState1: `${BASE_PATH}/question/state/1.svg`,
  questionState2: `${BASE_PATH}/question/state/2.svg`,
  questionState3: `${BASE_PATH}/question/state/3.svg`,
  questionState4: `${BASE_PATH}/question/state/4.svg`,
  questionState5: `${BASE_PATH}/question/state/5.svg`,
  
  // Result page
  detailBg: `${BASE_PATH}/result/detail-bg.svg`,
  // Score icon - 5 levels
  resultScoreIconLevel1: `${BASE_PATH}/result/score-icon-level1.png`,
  resultScoreIconLevel2: `${BASE_PATH}/result/score-icon-level2.png`,
  resultScoreIconLevel3: `${BASE_PATH}/result/score-icon-level3.png`,
  resultScoreIconLevel4: `${BASE_PATH}/result/score-icon-level4.png`,
  resultScoreIconLevel5: `${BASE_PATH}/result/score-icon-level5.png`,
  // Option 1 icon - 5 levels
  resultOptionIcon1Level1: `${BASE_PATH}/result/option-icon-1-level1.svg`,
  resultOptionIcon1Level2: `${BASE_PATH}/result/option-icon-1-level2.svg`,
  resultOptionIcon1Level3: `${BASE_PATH}/result/option-icon-1-level3.svg`,
  resultOptionIcon1Level4: `${BASE_PATH}/result/option-icon-1-level4.svg`,
  resultOptionIcon1Level5: `${BASE_PATH}/result/option-icon-1-level5.svg`,
  // Option 2 icon - 5 levels
  resultOptionIcon2Level1: `${BASE_PATH}/result/option-icon-2-level1.svg`,
  resultOptionIcon2Level2: `${BASE_PATH}/result/option-icon-2-level2.svg`,
  resultOptionIcon2Level3: `${BASE_PATH}/result/option-icon-2-level3.svg`,
  resultOptionIcon2Level4: `${BASE_PATH}/result/option-icon-2-level4.svg`,
  resultOptionIcon2Level5: `${BASE_PATH}/result/option-icon-2-level5.svg`,
  // Hint icons
  resultHintExcretion: `${BASE_PATH}/result/hint-icon-excretion.svg`,
  resultHintDigestion: `${BASE_PATH}/result/hint-icon-digestion.svg`,
  resultHintSkinImmunity: `${BASE_PATH}/result/hint-icon-skin-immunity.svg`,
  resultHintMindMood: `${BASE_PATH}/result/hint-icon-mind-mood.svg`,
  resultHintWeight: `${BASE_PATH}/result/hint-icon-weight.svg`,
  resultChevronDown: `${BASE_PATH}/result/chevron-down.svg`,
  resultArrowLeft: `${BASE_PATH}/result/arrow-left.svg`,
  
  resultScoreUp: `${BASE_PATH}/result/score-up.svg`,
  resultScoreDown: `${BASE_PATH}/result/score-down.svg`,
};

export default gutAssessmentImages;
